// extracted by mini-css-extract-plugin
export var actionText = "_m6-4";
export var container = "_m6-0";
export var leftSection = "_m6-1";
export var rightSection = "_m6-2";
export var settingsButton = "_m6-6";
export var settingsIcon = "_m6-7";
export var shortcut = "_m6-5";
export var shortcutGroup = "_m6-3";